// @ts-nocheck
import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { useLastUpdate } from '../contexts/LastUpdateContext';
import { Twitter, Linkedin, Github, Mail, Heart, RefreshCw } from 'lucide-react';

const Footer: React.FC = () => {
  const { isDark } = useTheme();
  const { lastUpdateTime } = useLastUpdate();
  const currentYear = new Date().getFullYear();

  const formatLastUpdateTime = (timestamp: string | null) => {
    if (!timestamp) return 'Never';

    const date = new Date(timestamp);
    return date.toLocaleString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZoneName: 'short'
    });
  };

  return (
    <footer className={`mt-auto border-t ${
      isDark
        ? 'bg-zinc-950 border-white/10'
        : 'bg-white border-gray-200'
    }`}>
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="md:col-span-1">
            <h3 className={`font-semibold text-lg mb-4 ${
              isDark ? 'text-white' : 'text-gray-900'
            }`}>
              InvestVerse.AI
            </h3>
            <p className={`text-sm ${isDark ? 'text-white/60' : 'text-gray-600'}`}>
              AI-powered cryptocurrency intelligence platform. Making institutional-grade analysis accessible to everyone.
            </p>
            <div className="flex items-center gap-3 mt-4">
              <button
                disabled
                className={`p-2 rounded-lg cursor-not-allowed opacity-40 ${
                  isDark
                    ? 'text-white/60'
                    : 'text-gray-600'
                }`}
                aria-label="Twitter (Coming Soon)"
                title="Link coming soon"
              >
                <Twitter className="h-4 w-4" />
              </button>
              <button
                disabled
                className={`p-2 rounded-lg cursor-not-allowed opacity-40 ${
                  isDark
                    ? 'text-white/60'
                    : 'text-gray-600'
                }`}
                aria-label="LinkedIn (Coming Soon)"
                title="Link coming soon"
              >
                <Linkedin className="h-4 w-4" />
              </button>
              <button
                disabled
                className={`p-2 rounded-lg cursor-not-allowed opacity-40 ${
                  isDark
                    ? 'text-white/60'
                    : 'text-gray-600'
                }`}
                aria-label="GitHub (Coming Soon)"
                title="Link coming soon"
              >
                <Github className="h-4 w-4" />
              </button>
              <button
                disabled
                className={`p-2 rounded-lg cursor-not-allowed opacity-40 ${
                  isDark
                    ? 'text-white/60'
                    : 'text-gray-600'
                }`}
                aria-label="Email (Coming Soon)"
                title="Link coming soon"
              >
                <Mail className="h-4 w-4" />
              </button>
            </div>
          </div>

          {/* Product Links */}
          <div className="md:col-span-1">
            <h3 className={`font-semibold text-sm mb-4 ${
              isDark ? 'text-white' : 'text-gray-900'
            }`}>
              Product
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/agent-analysis"
                  className={`text-sm transition-colors ${
                    isDark
                      ? 'text-white/60 hover:text-white'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  AI Agent Analysis
                </Link>
              </li>
              <li>
                <Link
                  to="/overview"
                  className={`text-sm transition-colors ${
                    isDark
                      ? 'text-white/60 hover:text-white'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  Market Overview
                </Link>
              </li>
              <li>
                <Link
                  to="/explore"
                  className={`text-sm transition-colors ${
                    isDark
                      ? 'text-white/60 hover:text-white'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  Trading Strategies
                </Link>
              </li>
              <li>
                <Link
                  to="/search"
                  className={`text-sm transition-colors ${
                    isDark
                      ? 'text-white/60 hover:text-white'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  Coin Search
                </Link>
              </li>
              <li>
                <Link
                  to="/strategy-advisor"
                  className={`text-sm transition-colors ${
                    isDark
                      ? 'text-white/60 hover:text-white'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  AI Strategy Advisor
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources Links */}
          <div className="md:col-span-1">
            <h3 className={`font-semibold text-sm mb-4 ${
              isDark ? 'text-white' : 'text-gray-900'
            }`}>
              Resources
            </h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="/docs"
                  className={`text-sm transition-colors ${
                    isDark
                      ? 'text-white/60 hover:text-white'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  Documentation
                </a>
              </li>
              <li>
                <a
                  href="/api"
                  className={`text-sm transition-colors ${
                    isDark
                      ? 'text-white/60 hover:text-white'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  API Reference
                </a>
              </li>
              <li>
                <a
                  href="/blog"
                  className={`text-sm transition-colors ${
                    isDark
                      ? 'text-white/60 hover:text-white'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  Blog
                </a>
              </li>
              <li>
                <a
                  href="/changelog"
                  className={`text-sm transition-colors ${
                    isDark
                      ? 'text-white/60 hover:text-white'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  Changelog
                </a>
              </li>
            </ul>
          </div>

          {/* Legal & Company */}
          <div className="md:col-span-1">
            <h3 className={`font-semibold text-sm mb-4 ${
              isDark ? 'text-white' : 'text-gray-900'
            }`}>
              Company
            </h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="/about"
                  className={`text-sm transition-colors ${
                    isDark
                      ? 'text-white/60 hover:text-white'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="/pricing"
                  className={`text-sm transition-colors ${
                    isDark
                      ? 'text-white/60 hover:text-white'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  Pricing
                </a>
              </li>
              <li>
                <a
                  href="/privacy"
                  className={`text-sm transition-colors ${
                    isDark
                      ? 'text-white/60 hover:text-white'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="/terms"
                  className={`text-sm transition-colors ${
                    isDark
                      ? 'text-white/60 hover:text-white'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className={`mt-8 pt-8 border-t flex flex-col sm:flex-row justify-between items-center gap-4 ${
          isDark ? 'border-white/10' : 'border-gray-200'
        }`}>
          <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-6">
            <p className={`text-sm ${isDark ? 'text-white/60' : 'text-gray-600'}`}>
              © {currentYear} InvestVerse.AI. All rights reserved.
            </p>
            {lastUpdateTime && (
              <div className={`flex items-center gap-2 text-xs ${
                isDark ? 'text-white/50' : 'text-gray-500'
              }`}>
                <RefreshCw className="h-3 w-3" />
                <span>Trading Strategies updated {formatLastUpdateTime(lastUpdateTime)}</span>
              </div>
            )}
          </div>
          <div className="flex items-center gap-2">
            <p className={`text-sm ${isDark ? 'text-white/60' : 'text-gray-600'}`}>
              Made with
            </p>
            <Heart className={`h-4 w-4 ${isDark ? 'text-red-400' : 'text-red-500'} fill-current`} />
            <p className={`text-sm ${isDark ? 'text-white/60' : 'text-gray-600'}`}>
              for crypto traders
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
